import "./App.scss";

import { SnackbarProvider } from "notistack";
import { RouterProvider } from "react-router/dom";

import { router } from "./router";

export function App() {
  return (
    <SnackbarProvider
      dense
      autoHideDuration={3000}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
    >
      <RouterProvider router={router} />
    </SnackbarProvider>
  );
}
